
import { React } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation, faBan } from '@fortawesome/free-solid-svg-icons'


import '../../main.css'
import './ScheduleDutyCard.css'
import './MScheduleDutyCard.css'
import { lP, oP } from '../../main.js'


export default function ScheduleDutyCard(props) {
    return (

        <div className={'scheduledutycard card noselect ' + props.className} onClick={(e) => { props.onclick(); e.preventDefault(); }}>
            <div className="scheduledutycard_left">
                <h5>{props.title}</h5>
                <p>{props.description}</p>
                <p className="scheduledutycard_warn">{!props.isFull ? "" : !props.waitlistEnabled ? <><FontAwesomeIcon icon={faBan} /> Bereits voll</> : props.editable ? <><FontAwesomeIcon icon={faTriangleExclamation} /> Helferliste voll - trotzdem vormerken?</> : <><FontAwesomeIcon icon={faTriangleExclamation} /> Warteliste</>}</p>
            </div>
            <label className="chb_container">
                <input type="checkbox" className="checkbox" name="schedulecardchb" value="1" checked={props.value} ></input>
                <span className={'checkmark ' + (props.isFull ? props.waitlistEnabled ? 'chb_warn' : 'chb_red' : 'chb_green')}></span>
            </label>
        </div>

    )
}
